<app-auth-layout>
  <app-domain-migration-notice auth-notice />
  <app-sign-in-flow></app-sign-in-flow>
</app-auth-layout>
